import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { trackEvent } from 'helpers/Analytics';
import { isUnread, markAsRead } from 'redux/modules/notifications';

const isPlainLeftClick = (event) =>
  event.button === 0 &&
  !event.metaKey &&
  !event.ctrlKey &&
  !event.shiftKey &&
  !event.altKey;

/**
 * Click handler for a notification: marks it read, then navigates inside the
 * app so the mark-read request isn't cancelled by a full page load.
 * Modifier clicks (new tab etc.) are left to the browser.
 */
export default function useOpenNotification(source, onNavigate) {
  const dispatch = useDispatch();
  const history = useHistory();

  return useCallback(
    (notification, content) => (event) => {
      trackEvent('notification-clicked', {
        notificationType: notification.type,
        source,
      });

      if (isUnread(notification)) {
        dispatch(markAsRead(notification.id));
      }

      if (event && isPlainLeftClick(event) && content.href) {
        event.preventDefault();
        history.push(content.href);

        if (onNavigate) {
          onNavigate();
        }
      }
    },
    [dispatch, history, source, onNavigate]
  );
}
